export const CLIENT_EVENTS_URL = '/events/';

export const CLIENT_API_EVENTS_URL = '/main/events/';
export const CLIENT_API_EVENTS_KEY = 'client_events_list';

export const CLIENT_API_EVENT_DETAIL_URL = '/main/events/';
export const CLIENT_API_EVENT_DETAIL_KEY = 'client_event_detail';

export const CLIENT_API_EVENT_CALENDAR_URL = '/main/event_calendar/';
export const CLIENT_API_EVENT_CALENDAR_KEY = 'client_event_calendar';

export const CLIENT_API_EVENT_SCHEDULE_URL = '/main/event_schedule/';
export const CLIENT_API_EVENT_SCHEDULE_KEY = 'client_event_schedule';

export const CLIENT_API_SPEAKER_DETAIL_URL = '/main/speakers/';
export const CLIENT_API_SPEAKER_DETAIL_KEY = 'client_speaker_detail';
export const CLIENT_API_SPEAKER_DETAIL_EVENTS_KEY =
  'client_speaker_detail_events';
